import { CommentPosition } from '@nusign/picflow-backend-types';
import { Rect } from '../classes/rect.class';

export const getCommentPositionCenter = (pos: CommentPosition): Rect => {
  if (Array.isArray(pos.x)) {
    return new Rect(
      pos.x[0] + (pos.x[1] - pos.x[0]) / 2,
      pos.y[0] + (pos.y[1] - pos.y[0]) / 2,
      pos.x[1] - pos.x[0],
      pos.y[1] - pos.y[0]
    );
  }
  return new Rect(pos.x as number, pos.y as number);
};
